import {
  COMPANY_INFO_REQUEST,
  COMPANY_INFO_REQUEST_ERROR,
  COMPANY_INFO_REQUEST_SUCCESS,
  COMPANY_INFO_UPDATE_USERS,
} from "actions/company";
import { saveCompanyProfile } from "services/companyProfile";
const initialState = {
  users: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMPANY_INFO_REQUEST:
      return { ...state, ...action };
    case COMPANY_INFO_REQUEST_ERROR:
      return { ...state, ...action };
    case COMPANY_INFO_REQUEST_SUCCESS:
      const addressPreferences = action?.addressPreferences;
      const customer = action?.customer;
      const intacctId = action?.intacctId;
      saveCompanyProfile({ addressPreferences, customer, intacctId });
      return { ...state, ...action };
    case COMPANY_INFO_UPDATE_USERS:
      return { ...state, users: action.users };
    default:
      return state;
  }
}
